import React, { useState, useEffect } from 'react';
import {
    Layout,
    Menu,
    Card,
    Row,
    Col,
    Typography,
    Button,
    Space,
    Badge,
    Input,
    Drawer,
    List,
    Avatar,
    Tag,
    Empty,
    Tooltip
} from 'antd';
import {
    MenuOutlined,
    FileTextOutlined,
    SafetyOutlined,
    ToolOutlined,
    CarOutlined,
    ExperimentOutlined,
    BarChartOutlined,
    ClockCircleOutlined,
    SearchOutlined,
    DownloadOutlined,
    EyeOutlined,
    CalendarOutlined,
    DashboardOutlined,
    EnvironmentOutlined,
    BugOutlined,
    DatabaseOutlined
} from '@ant-design/icons';
import DataList from './Data/DataList';
import { useSelector } from 'react-redux';
import InspectionDB from '@/services/indexDB/inspectionStore';
import inspectionService from '@/services/inspection.service';

const { Sider, Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;

const InspectionReportsUI = () => {
    const [selectedReportType, setSelectedReportType] = useState('');
    const [searchText, setSearchText] = useState('');
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [reportTypes, setReportTypes] = useState([])
    const { subscription } = useSelector(state => state.auth)
    const userdata = useSelector(state => state.auth)

    const [db] = useState(() => new InspectionDB());
    const [selectedDataSet, setSelectedDataSet] = useState([])
    const getReportsSubmenu = () => {
        return (userdata.subscription && userdata.subscription?.reports?.length) ? userdata.subscription?.reports?.map(x => (
            {
                label: x?.label, value: x?.label

            })) : []
    };


    useEffect(() => {
        setReportTypes([
            {label:"Inspection Report",value:"INSPECTION_REPORT"},            ...getReportsSubmenu()
        ]);
    }, [userdata.subscription])


    // Check if mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth < 1024) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);




    const getStatusColor = (status) => {
        switch (status) {
            case 'completed': return '#52c41a';
            case 'pending': return '#fa8c16';
            case 'in-progress': return '#1890ff';
            default: return '#d9d9d9';
        }
    };

    const getPriorityColor = (priority) => {
        switch (priority) {
            case 'high': return '#ff4d4f';
            case 'medium': return '#fa8c16';
            case 'low': return '#52c41a';
            default: return '#d9d9d9';
        }
    };

    const handleReportClick = async (report) => {
         const inspections = await db.getInspectionsByReportType(userdata.user.user_id, "INSPECTION_REPORT");
         const userCloudData = await inspectionService.getAllinspectionTimestamp("INSPECTION_REPORT")
        const mergeCloud = [...inspections, ...userCloudData?.data];
         setSelectedDataSet(mergeCloud);
        
    };

    const SidebarMenu = ({ isDrawer = false }) => (
        <div className="h-full flex flex-col">
            {/* Header */}
            <div className={`p-4 ${isDrawer ? 'linear-gradient(to right, #0087af, #00ae68)' : ''}`}>
                <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-lg flex items-center justify-center"
                        style={{ background: 'linear-gradient(135deg, #0087af, #00b654)' }}>
                        <DatabaseOutlined className="!text-white text-lg" />
                    </div>
                    {(!collapsed || isDrawer) && (
                        <div>
                            <Title level={4} className="mb-0 !text-white">
                                Database
                            </Title>
                            <Text className="!text-white/80 text-xs">Reports Dashboard</Text>
                        </div>
                    )}
                </div>
            </div>

            {/* Search */}
            {(!collapsed || isDrawer) && (
                <div className="px-4 pb-4">
                    <Search
                        placeholder="Search reports..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        allowClear
                        style={{
                            '& .ant-input': {
                                backgroundColor: 'rgba(255,255,255,0.1)',
                                border: '1px solid rgba(255,255,255,0.2)',
                                color: 'white'
                            }
                        }}
                    />
                </div>
            )}

            {/* Menu Items */}
            <div className="flex-1 px-2">
                <Menu
                    mode="inline"
                    selectedKeys={[selectedReportType]}
                    onClick={({ key }) => {
                        setSelectedReportType(key);
                        if (isMobile) setDrawerVisible(false);
                    }}
                    className="custom-menu"
                    inlineIndent={collapsed ? 0 : 24}
                    style={{
                        background: 'transparent',
                        border: 'none'
                    }}
                >
                    {reportTypes.map(type => (
                        <Menu.Item
                            key={type.key}
                            icon={type.icon}
                            onClick={(val) => handleReportClick(type.value)}

                            className="mb-1 mx-2 rounded-lg menu-item"
                        >
                            {(!collapsed || isDrawer) && (
                                <div className="flex justify-between items-center">
                                    <span className="text-sm font-medium">{type.label}</span>
                                    <Badge
                                        count={type.count}
                                        showZero
                                        style={{
                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                            color: 'white',
                                            border: '1px solid rgba(255,255,255,0.3)'
                                        }}
                                    />
                                </div>
                            )}
                        </Menu.Item>
                    ))}
                </Menu>
            </div>


        </div>
    );

    return (
        <>
            <style jsx global>{`
                .gradient-bg {
                    background: linear-gradient(135deg, #0087af, #00b654) !important;
                }
                
                .custom-menu {
                    background: transparent !important;
                    border: none !important;
                }
                
                .custom-menu .ant-menu-item {
                    background: transparent !important;
                    color: rgba(255, 255, 255, 0.9) !important;
                    margin: 4px 8px !important;
                    border-radius: 8px !important;
                    transition: all 0.3s ease !important;
                    border: none !important;
                    padding: 0 16px !important;
                    height: 44px !important;
                    line-height: 44px !important;
                }
                
                .custom-menu .ant-menu-item:hover {
                    background: rgba(255, 255, 255, 0.15) !important;
                    color: white !important;
                }
                
                .custom-menu .ant-menu-item-selected {
                    background: rgba(255, 255, 255, 0.2) !important;
                    color: white !important;
                    font-weight: 600 !important;
                }
                
                .custom-menu .ant-menu-item-selected::after {
                    display: none !important;
                }
                
                .custom-menu .anticon {
                    color: rgba(255, 255, 255, 0.9) !important;
                    font-size: 16px !important;
                }
                
                .custom-menu .ant-menu-item-selected .anticon {
                    color: white !important;
                }
                
                .custom-search .ant-input {
                    background: rgba(255, 255, 255, 0.15) !important;
                    border: 1px solid rgba(255, 255, 255, 0.3) !important;
                    color: white !important;
                    border-radius: 8px !important;
                }
                
                .custom-search .ant-input::placeholder {
                    color: rgba(255, 255, 255, 0.7) !important;
                }
                
                .custom-search .ant-input:focus {
                    border-color: rgba(255, 255, 255, 0.5) !important;
                    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1) !important;
                }
                
                .custom-search .ant-input-search-button {
                    background: rgba(255, 255, 255, 0.2) !important;
                    border: 1px solid rgba(255, 255, 255, 0.3) !important;
                    color: white !important;
                    border-radius: 0 8px 8px 0 !important;
                }
                
                .custom-search .ant-input-search-button:hover {
                    background: rgba(255, 255, 255, 0.3) !important;
                    color: white !important;
                }
                
                .report-card {
                    transition: all 0.3s ease !important;
                    border-left: 4px solid transparent !important;
                }
                
                .report-card:hover {
                    transform: translateY(-2px) !important;
                    box-shadow: 0 8px 25px rgba(0, 135, 175, 0.15) !important;
                    border-left-color: #0087af !important;
                }
                
                .mobile-header {
                    background: linear-gradient(135deg, #0087af, #00b654) !important;
                    border-bottom: none !important;
                }
                
                .ant-layout-sider-trigger {
                    background: rgba(0, 0, 0, 0.1) !important;
                    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
                }
                
                .ant-layout-sider-trigger:hover {
                    background: rgba(0, 0, 0, 0.2) !important;
                }
                
                .mobile-drawer .ant-drawer-body {
                    padding: 0 !important;
                }
            `}</style>

            <div className="min-h-screen bg-gray-50">
                <Layout className="min-h-screen">

                    {/* Desktop Sidebar */}
                    {!isMobile && (
                        <Sider
                            width={240}
                            style={{ height: "100vh", borderRadius: "5px" }}
                            collapsedWidth={80}
                            collapsed={collapsed}
                            onCollapse={setCollapsed}
                            className="gradient-bg  shadow-xl relative"
                            breakpoint="lg"
                            trigger={
                                <div className="flex items-center justify-center h-12 bg-black/10 hover:bg-black/20 transition-colors cursor-pointer">
                                    <MenuOutlined className="text-white" />
                                </div>
                            }
                        >
                            <SidebarMenu />
                        </Sider>
                    )}

                    <Layout>
                        {isMobile && (
                            <Button
                                type="text"
                                icon={<MenuOutlined />}
                                onClick={() => setDrawerVisible(true)}
                                className="text-white hover:bg-white/10 border-0"
                            />
                        )}

                        <Content className="px-2">
                            <DataList dataset={selectedDataSet} />
                        </Content>
                    </Layout>

                    {/* Mobile Drawer */}

                    <Drawer
                        title={
                            null
                        }
                        placement="left"
                        onClose={() => setDrawerVisible(false)}
                        open={drawerVisible}
                        bodyStyle={{ padding: 0 }}
                        width={280}
                        headerStyle={{
                            background: 'linear-gradient(to right, #0087af, #00ae68)',
                            borderBottom: '1px solid rgba(255,255,255,0.2)'
                        }}
                        bodyStyle={{
                            padding: 0,
                            background: 'linear-gradient(to right, #0087af, #00ae68)'
                        }}
                    >
                        <SidebarMenu isDrawer={true} />
                    </Drawer>


                </Layout>
            </div>
        </>
    );
};

export default InspectionReportsUI;